export { default as CsvIcon } from './component';
